import { useState, useEffect } from 'react';

// Check if phone immediately (for initial render)
const checkIsPhone = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const width = window.innerWidth;
  const height = window.innerHeight;
  const smallestDimension = Math.min(width, height);
  
  // Phones have smallest dimension under 500px
  // This excludes tablets (iPad Mini is 768px smallest dimension)
  const isSmallDevice = smallestDimension < 500;
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  return isSmallDevice && isTouchDevice;
};

// Detects if device is a phone (not tablet, not desktop)
export const useMobileDetect = (): boolean => {
  // Initialize with actual value, not false
  const [isPhone, setIsPhone] = useState(checkIsPhone);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(checkIsPhone());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isPhone;
};